/**
 * Created by Jie Gao on 2017-06-16.
 */

import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {WixxParsedGameData} from "../server/data/WixxParsedGameData";
import {WixxSoundConfig} from "../WixxSoundConfig";

export class WixxReelStopPresentationController extends ReelStopPresentationController {

    private _stackedReelFourRespin:boolean;
    private _isRespin:boolean;

    constructor(index:number) {
        super(index, "WixxReelStopPresentationController");

        this._isRespin = false;
        this._stackedReelFourRespin = false;
    }

    protected parseFeatureGameData(data:WixxParsedGameData):void {
        this._isRespin = data.mode === GameMode.RESPIN;
        this._stackedReelFourRespin = data.stackedReelFourRespinActive;
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        this.dispatchCompleteEvent(data.reelId);
    }

    public playReelBouncingSound(data:IReelStoppedData):boolean {
        if(this._stackedReelFourRespin && data.reelId === 3) {
            return true;
        }

        if(this._isRespin) {
            if(WixxSoundConfig.instance.REELS_BOOST_BOUNCE != null && WixxSoundConfig.instance.REELS_BOOST_BOUNCE[data.reelId] != null) {
                SlotGame.sound.playEffect(WixxSoundConfig.instance.REELS_BOOST_BOUNCE[data.reelId]);
                return true;
            }
        }

        return false;
    }

    protected resetFeature():void {
        this._isRespin = false;
        this._stackedReelFourRespin = false;
    }
}